"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertRequestConfig = void 0;
function convertRequestConfig(pubConfig, headers) {
    // Нет поддержки OPTIONS
    var method = pubConfig.method || (pubConfig.body ? 'POST' : 'GET');
    var scheme = pubConfig.uri.scheme || 'https';
    var port = pubConfig.uri.port || (scheme === 'https' ? 443 : 80);
    var withCredentials = typeof pubConfig.withCredentials === 'undefined' || pubConfig.withCredentials;
    var responseType = pubConfig.responseType || 'string';
    var requestType = pubConfig.requestType || 'string';
    var url = new URL("".concat(scheme, "://").concat(pubConfig.uri.host, ":").concat(port).concat(pubConfig.uri.path).concat(pubConfig.uri.query ? '?' + pubConfig.uri.query : ''));
    return {
        method: method,
        body: pubConfig.body,
        headers: headers,
        withCredentials: withCredentials,
        url: url,
        isExternal: false,
        responseType: responseType,
        requestType: requestType,
    };
}
exports.convertRequestConfig = convertRequestConfig;
//# sourceMappingURL=convertRequestConfig.js.map